<template>
  <div style="width: 100%;position: relative;height: auto;">
    <NBar title="场地收益趋势" :top="true"/>
    <div class="top">
      <div class="time-more">
        <div @click="timeItemClick(index)"
             :style="{backgroundColor:timeSelect === index ? '#ffffff' : '#e9e9e9',
             border:timeSelect === index ? '1px solid #194fff' : '1px solid #e9e9e9',
             color:timeSelect === index ? '#194fff' : '#a1a5ab'}"
             class="time-item" v-for="(item ,index) in timeList" :key="index">{{item.value}}
        </div>
      </div>
      <nut-cell @click.native="showSite = true"
                :show-icon="true">
        <span slot="title">场地</span>
        <span slot="desc" style="color: #1a87ff;">{{siteList[currSiteIndex].name}}</span>
      </nut-cell>
      <!--选择场地弹窗-->
      <nut-popup v-model="showSite" position="bottom" closeable :style="{height: '60%'}">
        <nut-cell style="margin-top: -3px;">
          <span slot="title" style="font-size: 16px;">选择场地</span>
          <span slot="desc"
                style="margin-right: 40px;font-size: 14px;color: #194fff;">{{siteList[0].deviceCount}}个</span>
        </nut-cell>
        <nut-searchbar ref="siteSearch" @submit="siteSearch" v-model="siteSearchName" place-text="请输入场地名称"
                       style="margin: 10px;"/>
        <nut-scroller style="height: 400px;" type="vertical" :is-loading="isSiteLoading" @pulldown="pullDownClick">
          <div slot="list">
            <nut-cell @click.native="siteItemClick(index)" v-for="(item ,index) in siteList" :key="index">
              <span slot="title"
                    :style="{color: index === currSiteIndex ? '#194fff' : '#2d2d2d'}">{{item.name}}</span>
              <span slot="desc" style="font-size: 14px;"
                    :style="{color: index === currSiteIndex ? '#194fff' : '#2d2d2d'}">{{item.deviceCount + '台'}}</span>
            </nut-cell>
          </div>
        </nut-scroller>
      </nut-popup>
      <!--选择场地弹窗 end-->
    </div>
    <nut-drag @click.native="switchDrag" :attract="true" direction="y" :boundary="boundary">
      <div
        style="user-select: none; border-top: 1px solid #1a87ff;border-bottom: 1px solid #1a87ff;border-left: 1px solid #1a87ff;padding: 5px 10px;color: #1a87ff;background-color: white;border-bottom-left-radius: 22px; border-top-left-radius: 22px;display: flex;align-items: center;">
        <img :src="require('../../../resource/img/device/svg/all.svg')"
             style="width: 15px;height: 15px;margin-right:5px;">
        <span>切换为{{earningsType === 0 ? '图表' : '列表'}}</span>
      </div>
    </nut-drag>
    <!--列表-->
    <div v-if="earningsType === 0" class="content">
      <div class="item" v-for="(item ,index) in list" :key="index">
        <nut-cell>
          <span slot="title" style="display: flex;align-items: center;">
            <div style="height: 15px;width: 3px;background-color: #1a87ff;margin-right: 5px;"></div>
            <span>{{item.countTime}}</span>
          </span>
        </nut-cell>
        <nut-cell>
          <div slot="avatar" style="margin-right: 10px;">
            <img :src="require('../../../resource/img/device/svg/earnings.svg')" style="width: 35px;height: 35px;">
          </div>
          <div slot="title" style="font-size: 16px;margin-top: 10px;">
            <span>合计收益</span>
            <nut-price :price="item.onlinePayMoney" :need-symbol="false" :thousands="true"/>
            <span>元</span>
          </div>
          <div slot="sub-title" style="font-size: 14px;margin-bottom: 20px;">
            <span>在线支付</span>
            <nut-price :price="item.onlinePayMoney" :need-symbol="false" :thousands="true"/>
            <span>元</span>
          </div>
        </nut-cell>
      </div>
    </div>
    <!--图表-->
    <div v-if="earningsType === 1" style="width: 100%; margin-top: 96px;">
      <v-chart @click="echartsClick" :options="options" style="height: 200px;width: 100%;"/>
      <div style="width: 100%;">
        <div style="font-size: 14px;height: 50px;line-height:50px;color:#2d2d2d;margin: 0 10px;">{{currItem.countTime}},
          收益
        </div>
        <div class="chart-price">
          <nut-price style="font-size: 20px;" :price="currItem.onlinePayMoney" :thousands="true" :need-symbol="false"/>
          <span>元</span>
        </div>
        <div
          style="display: flex;align-items: center;justify-content: space-around;margin-top: 20px;padding: 10px 0; border-bottom: 1px solid #d7d7d7;">
          <div style="display: flex;flex-direction: column;align-items: center;">
            <span style="color:#2d2d2d;font-size: 14px;margin-bottom: 5px;">在线支付</span>
            <div>
              <nut-price :thousands="true" :need-symbol="false" :price="currItem.onlinePayMoney"/>
              <span>元</span>
            </div>
          </div>
          <!--<div style="height: 50px;width: 1px;background-color: #d7d7d7;"></div>
          <div style="display: flex;flex-direction: column;align-items: center;">
            <span style="color:#2d2d2d;font-size: 14px;margin-bottom: 5px;">平台补贴</span>
            <div>
              <nut-price :thousands="true" :need-symbol="false" :price="0.00"/>
              <span>元</span>
            </div>
          </div>-->
        </div>
      </div>
    </div>
    <nut-backtop :bottom="80"/>
    <div style="height: 68px;"></div>
    <nut-tabbar ref="tab" @tab-switch="tabSwitch" :tabbar-list="tabList" :bottom="true"/>
  </div>
</template>

<script>

import VueECharts from 'vue-echarts'

/**
 * 场地收益趋势
 */
export default {
  name: 'SiteEarningsTrend',
  props: ['addressId'],
  data () {
    return {
      boundary: {top: 150, left: window.screen.width - 100, right: 0, bottom: 0},
      //当前选择时间索引
      timeSelect: 0,
      timeList: [
        {
          label: 0,
          value: '近7天'
        }, {
          label: 1,
          value: '近30天'
        }, {
          label: 2,
          value: '近6个月'
        }],
      //是否显示选择场地
      showSite: false,
      //场地查询
      siteSearchName: '',
      siteList: [
        {
          id: 0,
          name: '全部',
          deviceCount: 0
        }
      ],
      isSiteLoading: false,
      //当前选择的场地
      currSiteIndex: 0,
      //收益展示类型 0列表, 1图表
      earningsType: 0,
      list: [],
      currItem: {},
      options: {
        backgroundColor: '#2c343c',
        grid: {
          left: 0,
          right: 0,
          bottom: 0
        },
        xAxis: {
          type: 'category',
          data: ['01/01', '01/02', '01/03', '01/04', '01/05', '01/06', '01/07', '01/08', '01/09', '01/10', '01/11', '01/12', '01/13', '01/14', '01/14', '01/14', '01/14', '01/14', '01/14', '01/14', '01/14', '01/14'],
          position: 'top',
          z: 10,
          axisLine: {
            show: true,
            lineStyle: {
              color: 'rgb(122,142,136)'
            }
          },
          axisPointer: {
            show: true,
            type: 'line'
          },
          axisTick: {
            alignWithLabel: true
          }
        },
        yAxis: {
          type: 'value',
          show: false,
          axisLine: {
            show: false,
            lineStyle: {
              color: 'rgb(122,142,136)'
            }
          },
          axisTick: {
            show: false
          },
          splitLine: {
            show: false
          }
        },
        series: [{
          data: [12, 20, 15, 8, 7, 11, 13, 11, 15, 2, 1, 4, 18, 20, 15, 25, 15, 5, 2, 8, 4, 25, 4, 36, 5],
          type: 'bar',
          barWidth: 30,
          showBackground: false,
          itemStyle: {
            color: new VueECharts.graphic.LinearGradient(
              0, 0, 0, 1,
              [
                {offset: 0, color: '#83bff6'},
                {offset: 0.5, color: '#188df0'},
                {offset: 1, color: '#188df0'}
              ]
            ),
            // color: '#194fff',
            barBorderRadius: [15, 15, 0, 0]
          },
          selectedMode: true
        }],
        dataZoom: [
          {
            type: 'inside',// 内置于坐标系中
            start: 0,
            end: 30,
            zoomLock: true,
            xAxisIndex: [0]
          }
        ]
      },
      tabList: [
        {
          'tabTitle': '场地收益',
          'curr': false,
          'icon': require('../../../resource/img/device/svg/site_icon.svg'),
          'activeIcon': require('../../../resource/img/device/svg/site_icon_active.svg')
        },
        {
          'tabTitle': '收益趋势',
          'curr': true,
          'icon': require('../../../resource/img/device/svg/trends.svg'),
          'activeIcon': require('../../../resource/img/device/svg/trends_active.svg')
        },
        {
          'tabTitle': '数据分析',
          'curr': false,
          'icon': require('../../../resource/img/device/svg/data_analysis.svg'),
          'activeIcon': require('../../../resource/img/device/svg/data_analysis_active.svg')
        }
      ]
    }
  },
  activated () {
    this.$refs.tab.currIndex = 1
    this.getData()
    this.findSite(this.addressId)
  },
  methods: {
    tabSwitch: function (item, index) {
      switch (index) {
        case 0:
          this.$router.replace('/device/SiteEarnings')
          break
        case 1:
          this.getData()
          this.findSite(this.addressId)
          break
        case 2:
          this.$router.replace('/device/DataAnalysis')
          break
      }
    },
    echartsClick (el) {
      let {componentType, name} = el
      if (componentType === 'series') {
        let items = this.list.filter((item, index) => item.countTime === name)
        this.currItem = items[0]
      }
      console.log(el)
    },
    //日期快捷选择
    timeItemClick (index) {
      this.timeSelect = index
      this.getData()
    },
    //查询场地列表
    findSite (addressId) {
      let data = {}
      if (!this.$util.isArrOrNull(this.$api.merId)) {
        data.merId = this.$api.merId
      }
      if (!this.$util.isArrOrNull (this.$api.user.merIds)) {
        data.merIds = this.$api.user.merIds
      }
      if (this.siteSearchName != '') {
        data.searchName = this.siteSearchName
      }
      this.$api.post({
        url: '/device/api/device/address/find',
        data: data
      }).then(res => {
        let {data} = res
        this.siteList[0].deviceCount = data.map(item => item.deviceCount).reduce((prev, next) => prev + next)
        let siteListElement = this.siteList[0]
        this.siteList = [siteListElement]
        this.siteList = this.siteList.concat(res.data)
        this.isSiteLoading = false
        if (addressId) {
          this.siteList.forEach((item, index) => {
            if (addressId == item.id) {
              this.currSiteIndex = index
            }
          })
        }
      })
    },
    siteSearch (value) {
      this.siteSearchName = value
      //点击键盘中的’搜索‘时，失去焦点
      this.$refs.siteSearch.blur()
      this.findSite()
    },
    getData () {
      let time1 = new Date(this.$util.formatDate.format(new Date(), 'yyyy/MM/dd') + ' 00:00:00')
      let time2 = new Date(this.$util.formatDate.format(new Date(), 'yyyy/MM/dd') + ' 00:00:00')
      if (this.timeSelect === 0) {//七天
        time1 = new Date(((time1.getTime() / 1000) - (86400 * 7)) * 1000)
        time2 = time2
      }
      if (this.timeSelect === 1) {//1个月
        time1 = new Date(((time1.getTime() / 1000) - (86400 * 30)) * 1000)
        time2 = time2
      }
      if (this.timeSelect === 2) {//6个月
        let date = new Date()
        let monthTime = new Date(date.getFullYear(), date.getMonth() - 6, 1)
        time1 = new Date(this.$util.formatDate.format(monthTime, 'yyyy/MM') + '/01 00:00:00')
        date.setMonth(date.getMonth() + 1)
        date.setDate(date.getDate() - 1)
        time2 = new Date(this.$util.formatDate.format(date, 'yyyy/MM/dd') + ' 00:00:00')
      }
      let data = {
        timeType: this.timeSelect,
        addressId: this.addressId,
        startTime: time1.getTime() / 1000,
        endTime: time2.getTime() / 1000,
      }
      if (!this.$util.isArrOrNull(this.$api.merId)) {
        data.merId = this.$api.merId
      }
      if (!this.$util.isArrOrNull (this.$api.user.merIds)) {
        data.merIds = this.$api.user.merIds
      }
      this.$api.post({
        url: '/device/api/device/order/earnings-trend/list',
        data: data,
        loading: false
      }).then(res => {
        this.list = res.data
        let timeList = this.list.map((item, index) => item.countTime)
        let moneyList = this.list.map((item, index) => item.onlinePayMoney)
        this.options.xAxis.data = timeList
        this.options.series[0].data = moneyList
        this.currItem = this.list[0]
      })
    },
    pullDownClick () {
      this.isSiteLoading = true
      setTimeout(() => this.isSiteLoading = false, 100)
    },
    siteItemClick (index) {
      this.currSiteIndex = index
      this.addressId = this.siteList[index].id
      this.showSite = false
      this.getData()
    },
    switchDrag () {
      if (this.earningsType === 0) {
        this.earningsType = 1
      } else {
        this.earningsType = 0
      }
    }
  }
}
</script>

<style scoped>
  >>> .curr {
    color: #1a87ff;
  }

  .top {
    width: 100%;
    position: fixed;
    top: 40px;
    display: flex;
    flex-direction: column;
    background-color: white;
  }

  .top .time-more {
    margin: 10px 0;
    display: flex;
    align-items: center;
  }

  .top .time-more .time-item {
    font-size: 14px;
    background-color: #e9e9e9;
    border: 1px solid #e9e9e9;
    color: #a1a5ab;
    border-radius: 5px;
    padding: 5px 15px;
    margin-left: 10px;
  }

  .content {
    margin-top: 108px;
    width: 100%;
  }

  .content .item {
    margin-top: 10px;
    width: 100%;
  }

  .chart-price {
    text-align: center;
  }

  >>> .chart-price .nut-price .price-big {
    font-size: 32px;
    font-weight: bold;
  }

  >>> .chart-price .nut-price .price-point {
    font-weight: bold;
    font-size: 24px;
  }

  >>> .chart-price .nut-price .price-small {
    font-size: 24px;
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/components/device/home/SiteEarningsTrend.vue